// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1495) return "static/chunks/1495-808c986a58157de1.js";
	if (chunkId === 6895) return "static/chunks/6895-bd8148aa07f4de10.js";
	if (chunkId === 93) return "static/chunks/93-d0add35b90831bc4.js";
	if (chunkId === 8619) return "static/chunks/8619-4ef670f6fa41fab3.js";
	if (chunkId === 7216) return "static/chunks/7216-f2be1d7391f67999.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1281":"5fcc0bb073c0322b","1344":"673723604536d5bb","1497":"d96bb77a29f267b1","1865":"db7376d114b800cb","2293":"3f3a652b8777d386","2575":"7ac760eef2ab9b70","2707":"cc79bd8fa3292156","2839":"f8a076678f9c122f","3395":"2bc8e5e64ae94623","3633":"befca26d2f05000c","4055":"9fb5989bba677e4d","4072":"6223ac2da45f98d0","7045":"1eceeb738c500ad5"}[chunkId] + ".js";
};